import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SCROLL_THRESHOLD = 500;

export default function MobileScrollTopButton() {
  const { pathname, search } = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const scrollContainer = document.querySelector<HTMLElement>('[data-app-scroll-container]');

    if (!scrollContainer) return;

    const handleScroll = () => {
      setIsVisible(scrollContainer.scrollTop >= SCROLL_THRESHOLD);
    };

    handleScroll();
    scrollContainer.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [pathname, search]);

  const handleClick = () => {
    const scrollContainer = document.querySelector<HTMLElement>('[data-app-scroll-container]');

    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      aria-label="Scroll to top"
      onClick={handleClick}
      className={`fixed bottom-[5rem] right-3 z-[40] flex h-14 w-14 flex-col items-center justify-center rounded-full bg-gray-400 text-white shadow-lg transition-all duration-200 xs:hidden ${
        isVisible ? 'scale-100 opacity-100' : 'pointer-events-none scale-90 opacity-0'
      }`}
    >
      <i className="icon-arrow-down rotate-180 text-base leading-none" />
      <span className="text-[0.8rem] font-bold leading-none">TOP</span>
    </button>
  );
}
